import React from "react";
import TicketItemsList from "./TicketItemsList";

const TicketWindow = () => {
  return (
    <div>
      List of Tickets
      <div>
        <TicketItemsList />
      </div>
    </div>
  );
};

export default TicketWindow;
